import { atom } from 'recoil';

export const isVendorDocumentsFilterModalOpenAtom = atom<boolean>({
  key: 'isVendorDocumentsFilterModalOpenState',
  default: false,
});
